import { ReportTypes } from "@/app/reports/utils/enums";
import { getPaginationQuery } from "@/app/shared/utils/helpers";
import httpManager from "@/app/shared/utils/httpManager";

export interface CapturedLeadsDownloadDto {
  entity: number;
  portfolio: number;
  startDate: string;
  endDate: string;
}

export interface LeadsResumeFilters {
  entity: number;
  startDate: string;
  endDate: string;
}

class SequenceReportService {
  private getBaseUrl(type: number) {
    return `/reports/${type}`;
  }

  private getDatesParam(dates: string[]) {
    const startDate = `${dates.at(0)} 00:00:00`;
    const endDate = `${dates.at(1)} 23:59:59`;

    return `start_date=${startDate}&end_date=${endDate}`;
  }

  async downloadCapturedLeads(downloadDto: CapturedLeadsDownloadDto) {
    const { startDate, endDate, entity, portfolio } = downloadDto;

    const baseUrl = this.getBaseUrl(ReportTypes.CapturedLeads);
    const datesQuery = this.getDatesParam([startDate, endDate]);

    const url = `${baseUrl}/download/?${datesQuery}&portfolio=${portfolio}&entity=${entity}`;

    const response = await httpManager.post(url, {}, { blob: true });

    return response;
  }

  async getLeadsResume(filters: LeadsResumeFilters, page: number) {
    const { entity, startDate, endDate } = filters;

    const baseUrl = this.getBaseUrl(ReportTypes.LeadsResume);
    const datesQuery = this.getDatesParam([startDate, endDate]);
    const paginationQuery = getPaginationQuery(page);

    const url = `${baseUrl}/?${datesQuery}&${paginationQuery}&entity=${entity}`;

    const response = await httpManager.get(url);

    return response.data;
  }
}

export const sequenceReportService = new SequenceReportService();
